// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YUzYe","row":"Table_row__vg-qa"};